define('../app/fukit/behavior/hide.modal.on.event.behavior',['require','exports','module','underscore','backbone','marionette','bluebird','backbone.radio','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      Mn       = require('marionette'),
      Promise  = require('bluebird'),
      Radio    = require('backbone.radio'),
      UIKit    = require('uikit/uikit');

  var HideModalOnEventBehavior = Mn.Behavior.extend({
    onFirstRender: function() {
      //prettier-ignore
      var eventName = this.getOption('eventName'),
          eventSource = Mn._getValue(this.getOption('eventSource') || this.view, this);
      this.listenTo(eventSource, eventName, this.onEvent);
    },

    onEvent: function() {
      var modalName = this.getOption('modalName');
      Radio.request('modals', modalName ? 'hide:' + modalName : 'hideCurrent');
    },
  });

  module.exports = HideModalOnEventBehavior;
});

